import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

function sessionId() {
  let sid = sessionStorage.getItem("pg_sid");
  if (!sid) {
    sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem("pg_sid", sid);
  }
  return sid;
}

export default function OrganicTracker() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/admin") || location.pathname.startsWith("/staff-portal")) return;
    const firstView = !sessionStorage.getItem("pg_sid");
    const sid = sessionId();
    const params = new URLSearchParams(window.location.search);
    axios.post(`${API}/api/seo/track`, {
      path: location.pathname,
      referrer: firstView ? document.referrer || null : null,
      session_id: sid,
      is_landing: firstView,
      utm_source: params.get("utm_source"),
      gclid: params.get("gclid"),
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null;
}
